/* eslint-disable no-unused-vars */
import Vue from 'vue';
const $vm = Vue.prototype;

class BaseService {
    constructor(resource) {
        if (!resource) throw new Error('Path not provided');
        this.path = resource; 
    }

    errorHandler(data) {
        return data;
    }

    url({ id }) {
        const path = this.path;
        return id ? path.concat('/', id) : path;
    }
}

class ReadOnlyService extends BaseService {
    constructor(resource) {
        super(resource)
    }

    async get({ 
        id = '', 
        params = {} 
    } = {}) {
        try {
            const url = this.url({ id });
            const { data } = await $vm.$http(url, {params: {...params}});
            return { data }; 
        } catch (error) {
            if (error && error.response && error.response.data) {
                this.errorHandler(error.response.data);
            }
        }
    }
}

class ModelService extends BaseService {
    constructor(resource) {
        super(resource)
    }
    
    async post({ 
        method = 'POST', 
        headers, 
        id = '', 
        body = {} 
    } = {}) {
        try {
            const url = this.url({ id });
            const { data } = await $vm.$http(url, {
                method: method,
                data: body,
                headers: headers,
            })

            return { data };
        } catch (error) {
            if (error && error.response && error.response.data) {
                this.errorHandler(error.response.data);
            }
        }
    }
}

class PatchService extends BaseService {
    constructor(resource) {
        super(resource)
    }
    
    async patch({ 
        method = 'PATCH', 
        headers, 
        id = '', 
        body = {} 
    } = {}) {
        try {
            const url = this.url({ id });
            
            const { data } = await $vm.$http(url, {
                method: method,
                data: body,
                headers: {...headers},
            })

            return { data };
        } catch (error) {
            if (error && error.response && error.response.data) {
                this.errorHandler(error.response.data);
            }
        }
    }
}

class DeleteService extends BaseService {
    constructor(resource) {
        super(resource)
    }
    
    async delete({ 
        method = 'DELETE', 
        id = '', 
        body = {}
    } = {}) {
        try {
            const url = this.url({ id });
            
            const { data } = await $vm.$http(url, {
                method: method,
                data: body,
            })

            return { data };
        } catch (error) {
            if (error && error.response && error.response.data) {
                this.errorHandler(error.response.data);
            }
        }
    }
}

// Authorization

class Login extends ModelService {
    constructor() {
        super('recipients/login')
    }
}
class Precheck extends ReadOnlyService {
    constructor() {
        super('recipients/precheck')
    }
}
class Logout extends ModelService {
    constructor() {
        super('recipients/logout')
    }
}

//Profile
class AddRecipientProfile extends ModelService {
    constructor() {
        super('recipients-profiles/post-one-s')
    }
}

class EditRecipientProfile extends PatchService {
    constructor() {
        super('recipients-profiles/change-one-s')
    }
}

class GetRecipientProfile extends ReadOnlyService {
    constructor() {
        super('recipients-profiles/get-one-s')
    }
}

// Files

class GetFiles extends ReadOnlyService {
    constructor() {
        super('files/get-details')
    }
}

class AddFile extends ModelService {
    constructor() {
        super('files/add-image')
    }
}

export const $api = {
    login: new Login(),
    precheck: new Precheck(),
    logout: new Logout(),
    addRecipientProfile: new AddRecipientProfile(),
    editRecipientProfile: new EditRecipientProfile(),
    getRecipientProfile: new GetRecipientProfile(),
    getFiles: new GetFiles(),
    addFile: new AddFile(),
}